module.exports = __webpack_public_path__ + "img/slider_text_d2.af8c52d.900d73c1.png";